(() => {
  if (window.__ENSURE_FIRST_VARIANT_INIT__) return;
  window.__ENSURE_FIRST_VARIANT_INIT__ = true;

  const VARIANT_SELECTS_TAG = 'variant-selects';

  function isInputUnavailable(input) {
    if (!input) return true;
    if (input.disabled) return true;
    if (input.classList.contains('disabled')) return true;
    if (input.classList.contains('visually-disabled')) return true;
    return false;
  }

  function isColorFieldset(fieldset) {
    if (!fieldset) return false;
    return !!fieldset.querySelector('input[data-color-handle], input[data-color-value-handle]');
  }

  function ensureFieldsetSelection(fieldset) {
    if (!fieldset) return;
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    if (radios.length === 0) return;

    const radiosArr = Array.from(radios);
    const checkedRadio = radiosArr.find(r => r.checked);
    if (checkedRadio && !isInputUnavailable(checkedRadio)) return;

    const firstAvailable = radiosArr.find(r => !isInputUnavailable(r));
    if (!firstAvailable) return;
    if (firstAvailable === checkedRadio) return;

    if (checkedRadio) checkedRadio.checked = false;
    firstAvailable.checked = true;
    firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
    firstAvailable.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function ensureSelectSelection(select) {
    if (!select) return;
    const options = Array.from(select.options || []);
    if (options.length === 0) return;

    const anySelected = options.some(o => o.selected);
    if (anySelected) return;

    options[0].selected = true;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureAllSelections() {
    document.querySelectorAll(`${VARIANT_SELECTS_TAG} fieldset`).forEach(fieldset => {
      if (isColorFieldset(fieldset)) return;
      ensureFieldsetSelection(fieldset);
    });
    document.querySelectorAll(`${VARIANT_SELECTS_TAG} select`).forEach(ensureSelectSelection);
  }

  let debounceTimer = null;
  function scheduleEnsure(delay) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      ensureAllSelections();
    }, delay);
  }

  function hasPersistedVariantSelection() {
    const params = new URLSearchParams(window.location.search);
    return params.has('variant') || params.has('selected');
  }

  function init() {
    if (!hasPersistedVariantSelection()) {
      setTimeout(ensureAllSelections, 500);
      setTimeout(ensureAllSelections, 1200);
    }

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest(VARIANT_SELECTS_TAG)) return;
      scheduleEnsure(180);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => scheduleEnsure(80));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
